const { isChoiceEligible } = require('../experiments/choiceExpansion');

const isFiverrChoice = ({ queryParameters, abTests, choiceEligibilities }) => {
    if (!queryParameters.fiverr_choice) {
        return false;
    }

    return isChoiceEligible(abTests, choiceEligibilities);
};

module.exports = {
    isFiverrChoice
};
